import { createAction } from "typesafe-actions";
import { TrainStop, TrainStation } from './types';

// Actions - no need for constants to be used elsewhere!
const SET_SELECTED_ROUTE = "SET_SELECTED_ROUTE";
const SET_STOPS = "SET_STOPS";
const SET_STATIONS = "SET_STATIONS";
const SET_MAX_TRIPS = "SET_MAX_TRIPS";
const SET_ROUTE_DATA = "SET_ROUTE_DATA"; // load stops and stations simultaneously
const SET_SELECTED_STATIONS = "SET_SELECTED_STATIONS"; // load stops and stations simultaneously
const SET_TIME_RANGE = "SET_TIME_RANGE"; // load stops and stations simultaneously

// Action creators
export const setSelectedRoute = createAction(
  SET_SELECTED_ROUTE,
  action => (routeId: string) =>
    action({
      routeId
    })
);

export const setStops = createAction(
  SET_STOPS,
  action => (stops: TrainStop[]) => action({ stops })
);

export const setStations = createAction(
  SET_STATIONS,
  action => (stations: TrainStation[]) => action({ stations })
);

export const setMaxTrips = createAction(
  SET_MAX_TRIPS,
  action => (maxTrips: number) => action({ maxTrips })
);


export const setRouteData = createAction(
  SET_ROUTE_DATA,
  action => (stops: TrainStop[], stations: TrainStation[]) => action({ stops, stations })
);


export const setSelectedStations = createAction(
  SET_SELECTED_STATIONS,
  action => (stations: TrainStation[]) => action({ stations })
);


export const setTimeRange = createAction(
  SET_TIME_RANGE,
  action => (start: Date, end: Date) => action({ start, end })
);
